<template>
  <div class="card px-2 py-2 mt-3 wrapper-reviews">
    <div>
      <button class="btn" style="box-shadow: none;" @click="visible = !visible">
        <i class="fas fa-star"></i>
        {{ this.$t('reports.reviewsGroup.reviewsLabel') }}
      </button>
      <button
        class="btn pull-right"
        style="box-shadow: none;"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="wrapper-rankings card" v-if="loader">
      <div>
        <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" id="reviews" class="mt-2">
        <b-table :fields="fields" :items="items" caption-bottom sort-icon-left>
          <template v-slot:cell(question)="row">
            <div style="max-width: 80%;">
              {{ row.item.question }}
            </div>
          </template>
          <template v-slot:cell(score)="row">
            <div class="text-center">
              {{ row.item.score }}
            </div>
          </template>
          <template v-slot:cell(scoreGroup)="row">
            <div class="text-center">
              {{ row.item.scoreGroup }}
            </div>
          </template>
          <template v-slot:cell(scoreGeral)="row">
            <div class="text-center">
              {{ row.item.scoreGeral }}
            </div>
          </template>
        </b-table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/services/api';
import EventBus from '../../../../../../eventBus';

export default {
  name: 'ReviewsGroup',
  props: ['showCollapsed', 'selectedBranch', 'selectedGroup'],
  components: {},
  data: () => ({
    isBusy: false,
    userAuth: null,
    filter: null,
    visible: true,
    total: 0,
    page: 1,
    limit: 10,
    reviewsData: [],
    loader: false,
    fields: [],
    items: [],
  }),
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountReview();
    },
    myActionId: function watchMyActionId() {
      this.mountReview();
    },
    myActionsIds: function watchMyActionsIds() {
      this.mountReview();
    },
    myIh1: function watchMyIh1() {
      this.mountReview();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.mountReview();
    },
    myIh2: function watchMyIh2() {
      this.mountReview();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.mountReview();
    },
    calendarDates: function watchDates() {
      this.mountReview();
    },
    myMetric: function watchMyMetric() {
      this.mountReview();
    },
    'indicatorData.value': function watchIndicatorData() {
      this.mountReview();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountReview();
    },
  },
  computed: {
    ...mapState('charts', ['filterRankings']),
    ...mapState('actions', ['myActionId', 'myActionsIds', 'actionGroupData']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    async mountReview() {
      this.loader = true;
      const response = await api.get(`reports/get-reviews-group`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: this.filterRankings ? this.filterRankings : null,
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          selectedBranch: this.selectedBranch,
          selectedGroup: this.selectedGroup,
        },
      });
      this.reviewsData = response.data;
      this.items = [];
      this.reviewsData.map((obj) => {
        this.items.push({
          question: obj.question,
          progress: obj.average,
          score: obj.averageAllBranches,
          scoreBranch: obj.averageBranch,
          scoreGroup: obj.averageGroup,
          total: obj.totalAllBranches,
        });
        this.total = this.total + obj.total;
        this.sortDesc = true;
        this.isBusy = false;
      });
      this.loader = false;
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.reviewsGroup.addQuestionLabel'),
        sortable: true,
        class: 'questionTh',
      },
      {
        key: 'scoreBranch',
        label: this.$t('reports.reviewsGroup.branchLabel'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'scoreGroup',
        label: this.$t('reports.reviewsGroup.groupLabel'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'score',
        label: this.$t('reports.reviewsGroup.companyLabel'),
        sortable: true,
        class: 'scoreTh',
      },
    ];
  },
  mounted() {
    this.visible = !this.showCollapsed;
    this.mountReview();
    EventBus.$on('filter-rankings', () => {
      this.mountReview();
    });
  },
};
</script>

<style lang="scss">
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-reviews .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-reviews .btn .btn-light .collapsed {
  background-color: transparent;
}
.wrapper-rankings.card {
  min-height: 200px;
}
.wrapper-rankings .loader {
  min-height: 200px;
}
.card {
  border: 1px solid rgba(0, 0, 0, 0.09);
}
.scoreTh,
.totalTh {
  width: 70px;
  padding-right: 0px !important;
}
.questionTh {
  width: calc(100% - 200px);
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/reviews-group.vue